import {
  addDoc,
  collection,
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../../../firebase";

const isValidPrice = (n) => Number.isFinite(n) && n > 0;

export const createProduct = async ({
  name,
  type,
  imageUrl,
  isActive,
  price,
  shenime,
}) => {
  const priceNum = Number(price);
  if (!isValidPrice(priceNum)) {
    throw new Error("Çmimi duhet të jetë numër valid.");
  }

  return addDoc(collection(db, "products"), {
    name: String(name || "").trim(),
    type,
    imageUrl: imageUrl || "",
    isActive: Boolean(isActive),
    price: priceNum,
    shenime: String(shenime || "").trim(),
    createdAt: serverTimestamp(),
  });
};

/** All products (active + inactive) for catalog that shows "Mungon në stok" */
export const getProducts = async () => {
  const snapshot = await getDocs(collection(db, "products"));
  return snapshot.docs.map((d) => ({
    id: d.id,
    ...d.data(),
  }));
};

/** Single product by id for details page */
export const getProductById = async (id) => {
  if (!id) return null;
  const snap = await getDoc(doc(db, "products", id));
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
};

export const getActiveProducts = async () => {
  const q = query(
    collection(db, "products"),
    where("isActive", "==", true)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({
    id: d.id,
    ...d.data(),
  }));
};

export const deleteProduct = async (id) => {
  return deleteDoc(doc(db, "products", id));
};

export const setProductActive = async (id, isActive) => {
  return updateDoc(doc(db, "products", id), {
    isActive: Boolean(isActive),
  });
};

/** Update product (name, type, price, shenime, isActive, imageUrl) */
export const updateProduct = async (id, { name, type, price, shenime, isActive, imageUrl }) => {
  const priceNum = Number(price);
  if (!isValidPrice(priceNum)) {
    throw new Error("Çmimi duhet të jetë numër valid.");
  }
  const updates = {
    name: String(name || "").trim(),
    type,
    price: priceNum,
    shenime: String(shenime || "").trim(),
    isActive: Boolean(isActive),
  };
  if (imageUrl !== undefined) updates.imageUrl = imageUrl || "";
  return updateDoc(doc(db, "products", id), updates);
};
